import styled from '@emotion/styled';
import React from 'react';
import { MOBILE_BP } from './Calendar.styled';
import { IEventBlock } from './types';

const capitalised = (text?: string) => `${text?.slice(0, 1).toUpperCase()}${text?.slice(1)}`;

const channelMapping: { [key: string]: string } = {
	'www.vrbo.com': 'Vrbo',
	'airbnb.com': 'Airbnb',
	'booking.com': 'Booking.com',
	'my.hometogo.com': 'HomeToGo',
	'my-api.hometogo.com': 'HomeToGo',
	'www.expediapartnercentral.com': 'Expedia',
	'api.host.holidu.com': 'Holidu',
	'calendar.google.com': 'Google Calendar',
};

const getChannelName = (channel: string): string => {
	const cleanedChannel = channel.replace(/^import:/, '');
	return channelMapping[cleanedChannel] || cleanedChannel;
};

export const getSubheading = (event: IEventBlock): string | null => {
	switch (event.event.status || 'blocked') {
		case 'blocked':
		default:
			return event.event.data?.block_reason_note
				|| event.event.data?.block_reason_source
				|| 'Dates not available for bookings';
		case 'booked':
			const guests: number | undefined = event.event.data?.guests;
			if (guests !== undefined) {
				const suffix = guests > 1 ? 's' : '';
				return `${guests} guest${suffix}`;
			} else {
				return null;
			}
		case 'synced':
			const channel: string | undefined = event.event.data?.channel;

			if (channel !== undefined) {
				return getChannelName(channel);
			} else {
				return null;
			}
	}
};

const Wrapper = styled.div<{ eventType: string | undefined }>`
	font-family: sans-serif;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;

	.title, .subtitle {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		min-width: 10px;
	}

	.title {
		font-weight: 700;
		font-size: 12px;
		line-height: 15px;
	}

	.subtitle {
		display: none;
		font-weight: normal;
		font-size: 12px;
		line-height: 15px;
	}

	@media only screen and (min-width: ${MOBILE_BP}) {
		.subtitle {
			display: block;
			font-size: 11px;
		}
	}
`;

export const EventDetail: React.FC<{ event: IEventBlock }> = ({ event }) => {

	const subheading = getSubheading(event);

	return <Wrapper eventType={event.event.status}>
		<span className="title" style={{ display: 'block' }}>{capitalised(event.event.text)}</span>
		{subheading && <span className="subtitle">{subheading}</span>}
	</Wrapper>;
};
